/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react/jsx-no-target-blank */
import React, { useState, useEffect } from "react";
import sitesData from "../../data/data";
import GitService from "../../services/gitlab";

export default function DemoDeployment({ theme, isCoreTheme }) {
  // eslint-disable-next-line no-unused-vars
  const [deploying, setDeploying] = useState(false);
  const [pipelineURL, setPipelineURL] = useState(null);
  const [selectedSite, setSelectedSite] = useState("");
  const [allSites, setAllSites] = useState([]);
  const [latestDemo, setLatestDemo] = useState({});
  const [date, setDate] = useState("");

  useEffect(() => {
    if (isCoreTheme) {
      const allThemes = sitesData()
        .themes.filter((each) => each.id === 490)
        .map((each) => {
          return each.sites;
        })
        .flat();

      setAllSites(allThemes);
    }
    getDemoDeployments();
  }, [isCoreTheme]);

  const triggerPipeline = () => {
    GitService.triggerDeploy(
      theme.id,
      theme.pipeline_trigger_token,
      selectedSite
    ).then((response) => {
      if (response.data.status === "created") {
        const pipeline = response.data;

        setDeploying(true);
        setPipelineURL(pipeline.web_url);
        setDate(new Date(pipeline.created_at).toLocaleString());
        setLatestDemo(pipeline);
      }
    });
  };

  const getDemoDeployments = () => {
    GitService.getDemoDeployments(theme.id).then((job) => {
      GitService.getPipelineVariables(theme.id, job.pipeline.id).then(
        (pipeline) => {
          const lastDeployedSite = pipeline.data.find(
            (each) => each.key === "SITE_NAME"
          );

          setLatestDemo(job);
          setDate(new Date(job?.created_at).toLocaleString());
          setSelectedSite(
            typeof lastDeployedSite !== "undefined"
              ? lastDeployedSite.value
              : theme.defaultSite
          );

          if (job.status === "running") {
            setDeploying(true);
            setPipelineURL(job.pipeline.web_url);
          }
        }
      );
    });
  };

  return (
    <div className="card">
      <div className="card-header">
        <h3 className="card-title">Demo Deployment</h3>
        <div className="dropdown d-inline-block col-md-4 ml-auto">
          <input
            type="text"
            className="form-control"
            value={selectedSite}
            readOnly
            placeholder="Select... (type to search)"
          />
          <datalist className="dropdown-menu">
            {isCoreTheme
              ? allSites.map((site) => (
                  <option
                    key={site.id}
                    onClick={() => setSelectedSite(site.name)}
                  >
                    {site.name}
                  </option>
                ))
              : theme.sites.map((site) => (
                  <option
                    key={site.id}
                    onClick={() => setSelectedSite(site.name)}
                  >
                    {site.name}
                  </option>
                ))}
            <option key='222' onClick={() => setSelectedSite("demosite")}>
              demosite
            </option>
          </datalist>
        </div>
        <div className="right-element">
          <button
            className={`btn btn-info ml-2 btn-sm ${pipelineURL && "disabled"}`}
            onClick={triggerPipeline}
          >
            <i className="uil uil-refresh"></i>Deploy
          </button>
        </div>
      </div>
      <div className="card-body">
        {latestDemo?.user && (
          <table className="table">
            <thead>
              <tr>
                <th>Last Deployed By</th>
                <th>Date and Time</th>
                <th>Status</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  <div className="avatar avatar-sm bg-yellow">
                    <img src={latestDemo?.user?.avatar_url} alt="user avatar" />
                  </div>
                  {latestDemo?.user?.name}
                </td>
                <td>{date}</td>
                <td>
                  {latestDemo.status !== "success" ? (
                    <>
                      <label className="m-0">In Progress</label>
                      <span className="float-right additional"></span>
                      <div className="progress">
                        <div className="progress-bar w-76 bg-warning"></div>
                      </div>
                    </>
                  ) : (
                    <>
                      <label className="m-0">Complete</label>
                      <span className="float-right additional">100%</span>
                      <div className="progress">
                        <div className="progress-bar w-100 bg-success"></div>
                      </div>
                    </>
                  )}
                </td>
                <td className="">
                  <a
                    target="_blank"
                    href={
                      latestDemo.status !== "success"
                        ? pipelineURL
                        : latestDemo.pipeline.web_url
                    }
                    className={`btn btn-sm ${
                      latestDemo.status !== "success"
                        ? "btn-warning"
                        : "btn-primary"
                    } `}
                  >
                    <i className="uil uil-globe"></i>
                    Url
                  </a>
                </td>
              </tr>
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}